import styled from 'styled-components';

const SettingsPageTitleWrapper = styled.div`
  display: flex !important;
  flex-direction: column;
  justify-content: flex-start;
  flex: 1;
  height: auto;
`;

export { SettingsPageTitleWrapper };
